import React from "react";
import "./AboutActivity.scss";
// import Button from "../Button";

const AboutActivity = ({push}) => {
    return (
        <section className="wtm-about-workshop">
            <div className="container">
                <div className="title">
                    <h1>More Activities</h1>
                    {/*<Button btnText="더 알아보기" extraClassName="btn-main-event btn-green btn-sm"*/}
                    {/*url="/activity" push={push}/>*/}
                </div>
                <div className="list">
                    <ul className="card-list">
                        <li className="card">
                            <div className="content">
                                <img src="/img/activity/networking.png" alt=""/>
                                <h1 className="title">스피드 네트워킹</h1>
                                <p className="desc">
                                    함께 일하는 워먼 테크메이커의 이야기가 궁금하신가요?
                                    어색할 틈도 없는 2분이라는 짧은 시간동안 각각 5명의 참가자와, 총 10분동안 이야기를 나눌수 있어요. 빠르게 마음맞는 친구들을 찾아보세요!
                                </p>
                                <p>*세션 사이 쉬는 시간에만 운영될 예정입니다.</p>
                            </div>
                            <div className="img-container">
                                <img src="" alt=""/>
                            </div>
                        </li>
                        <li className="card">
                            <div className="content">
                                <img src="/img/activity/codelab.png" alt=""/>
                                <h1 className="title">코드랩</h1>
                                <p className="desc">
                                    다양한 코드랩을 튜터분들과 함께 진행해보세요!
                                    검증된 교육자료(퀵랩/콜랩)로 배우고 싶었던 내용을 코드랩을 통해 배워볼 수 있습니다.
                                    따라가지 못할까 걱정할 필요 없이 본인이 원하는 원하는 속도로 직접 진행하고, 도움이 필요하면 튜터에게 알려주세요.
                                </p>
                                <p>
                                    *모든 코드랩 참여자분들께 퀵랩 1달 체험 쿠폰을 드려요!
                                </p>
                            </div>
                            <div className="img-container">
                                <img src="" alt=""/>
                            </div>
                        </li>
                        <li className="card">
                            <div className="content">
                                <img src="/img/activity/study.png" alt=""/>
                                <h1 className="title">스터디그룹 메이킹</h1>
                                <p className="desc">
                                    실력을 향상 시키는 데에는 꾸준한 스터디만큼 좋은 것이 없죠!
                                    여성 멤버로만 구성된 스터디를 진행 해보는 것은 어떠세요?
                                    하고 싶은 스터디는 있는 스터디원을 못 구한 사람, 참여하고 싶은 스터디가 있는 사람 모두 모이세요!!!
                                </p>
                            </div>
                            <div className="img-container">
                                <img src="" alt=""/>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
    );
};

export default AboutActivity;
